export function commercialReturnReducer(state = "",{
    type,
    payload
}){
    
    switch(type){
        case "NEW_COMMERCIAL_RETURN": 
            return {
                [payload.id]: payload,
                ...state
            };

        case "UPDATE_COMMERCIAL_RETURN": 
            return {
                ...state,
                [payload.id]: payload
            } 
            
        case "GET_COMMERCIAL_RETURNS":        
            return payload;
        
        case "DELETE_COMMERCIAL_RETURN":
            const { [payload]: deleted, ...newState } = state;
            return newState;
        default:
            return state;
    }
    
}